function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { createContext, useEffect, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import { fetchWaveformData } from './services/waveformService';
import { keysToCamel } from './utils';
import playerReducer from './player.reducer';
import { useAudio } from './hooks/useAudio';
import { useSessionStorage } from './hooks/useSessionStorage';
export var PlayerContext = /*#__PURE__*/createContext(undefined);
export var PlayerApiContext = /*#__PURE__*/createContext(null);
export var PlayerAudioContext = /*#__PURE__*/createContext(null);
var initialState = {
  currentTrack: null,
  isPlaying: false,
  queue: [],
  playHistory: []
};
var PlayerProvider = function PlayerProvider(_ref) {
  var children = _ref.children;
  var _useAudio = useAudio(),
    play = _useAudio.play,
    pause = _useAudio.pause,
    reset = _useAudio.reset,
    mute = _useAudio.mute,
    unmute = _useAudio.unmute,
    setVolume = _useAudio.setVolume,
    setCurrentTime = _useAudio.setCurrentTime,
    skipBackwards = _useAudio.skipBackwards,
    skipForwards = _useAudio.skipForwards,
    playNewTrack = _useAudio.playNewTrack,
    audioElement = _useAudio.audioElement;
  var _useReducer = useReducer(playerReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    playerState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useSessionStorage = useSessionStorage('userPlayHistory', []),
    _useSessionStorage2 = _slicedToArray(_useSessionStorage, 2),
    sessionHistory = _useSessionStorage2[0],
    setSessionHistory = _useSessionStorage2[1];
  useEffect(function () {
    dispatch({
      type: 'initialisePlayHistory',
      sessionHistory: sessionHistory
    });
    return function () {
      dispatch({
        type: 'stop'
      });
    };
  }, []);
  var togglePlay = function togglePlay(inputTrack, args) {
    var track = keysToCamel(inputTrack);
    dispatch({
      type: 'togglePlay',
      track: track,
      pause: pause,
      play: play,
      args: args
    });
    dispatch({
      type: 'initialPlay',
      track: track,
      playNewTrack: playNewTrack,
      analyticArgs: args,
      setSessionHistory: setSessionHistory
    });
    dispatch({
      type: 'setCurrentTrack',
      track: track
    });
  };
  var simpleTogglePlay = function simpleTogglePlay() {
    return dispatch({
      type: 'simplePlay',
      pause: pause,
      play: play,
      playNewTrack: playNewTrack,
      setSessionHistory: setSessionHistory
    });
  };
  var initialiseQueue = function initialiseQueue(inputTracks) {
    var tracks = inputTracks.map(function (track) {
      return keysToCamel(track);
    });
    dispatch({
      type: 'initialiseQueue',
      tracks: tracks
    });
    fetchWaveformData(tracks);
  };
  var playNextTrack = function playNextTrack() {
    dispatch({
      type: 'playNextTrack',
      reset: reset,
      playNewTrack: playNewTrack,
      setSessionHistory: setSessionHistory
    });
  };
  var playPreviousTrack = function playPreviousTrack() {
    dispatch({
      type: 'playPreviousTrack',
      playNewTrack: playNewTrack,
      reset: reset,
      setSessionHistory: setSessionHistory
    });
  };
  var playerApi = useMemo(function () {
    return {
      togglePlay: togglePlay,
      simpleTogglePlay: simpleTogglePlay,
      initialiseQueue: initialiseQueue,
      playNextTrack: playNextTrack,
      playPreviousTrack: playPreviousTrack,
      mute: mute,
      unmute: unmute,
      setVolume: setVolume
    };
  }, []);
  var audioApi = useMemo(function () {
    return {
      audioElement: audioElement,
      setCurrentTime: setCurrentTime,
      skipBackwards: skipBackwards,
      skipForwards: skipForwards
    };
  }, [audioElement]);
  return /*#__PURE__*/React.createElement(PlayerAudioContext.Provider, {
    value: audioApi
  }, /*#__PURE__*/React.createElement(PlayerApiContext.Provider, {
    value: playerApi
  }, /*#__PURE__*/React.createElement(PlayerContext.Provider, {
    value: playerState
  }, children)));
};
PlayerProvider.propTypes = {
  children: PropTypes.element.isRequired
};
export default PlayerProvider;